import { DatePicker, Radio } from 'antd';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import style from './ChartPerformance.module.scss';
export default function ChartPerformance(props) {
  const { getDataPerformanceChart, dataChart, dateTime, setDateTime, isTitle, setIsTitle } = props;
  const { output_e, estimated_e, performance_ratio } = dataChart;

  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  // const [dateTime, setDateTime] = useState(moment().format('YYYY-MM-DD'));
  // const [isTitle, setIsTitle] = useState('week');

  useEffect(() => {
    if (chartRef && chartRef.current && chartInstance == null) {
      const newChartInstance = new Chart(chartRef.current, chartConfig);
      setChartInstance(newChartInstance);
    }
  }, []);

  useEffect(() => {
    if (chartInstance) {
      updateDataset(0, dataChart.performance_ratio);
      updateDataset(1, dataChart.output_e);
      updateDataset(2, dataChart.estimated_e);
      // updateUnit(isPickerTwo);
      updateUnit(isTitle);
    }
  }, [dataChart]);

  const updateDataset = (datasetIndex, newData) => {
    chartInstance.data.datasets[datasetIndex].data = newData;
    chartInstance.update();
  };

  const updateUnit = (isPickerTwo) => {
    let newUnit = '';
    if (isPickerTwo === 'year') {
      newUnit = 'month';
    } else {
      newUnit = 'day';
    }
    chartInstance.options.scales.x.time.unit = newUnit;
    chartInstance.update();
  };

  const data = {
    datasets: [
      {
        type: 'line',
        unit: '%',
        label: 'Performance ratio',
        data: performance_ratio,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        backgroundColor: '#ff3c2e',
        borderColor: '#ff3c2e',
        yAxisID: 'y1',
      },
      {
        type: 'bar',
        label: 'Output energy',
        unit: 'kWh',
        data: output_e,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        backgroundColor: '#038cfc',
        yAxisID: 'y',
      },
      {
        type: 'bar',
        label: 'Estimated output energy',
        unit: 'kWh',
        data: estimated_e,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        backgroundColor: '#fcc603',
        yAxisID: 'y',
      },
    ],
  };

  const chartConfig = {
    data: data,
    options: {
      maintainAspectRatio: false,
      elements: {
        point: {
          radius: 3,
        },
        line: {
          tension: 0.3,
        },
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },
      plugins: {
        title: {
          text: 'Chart.js Time Scale',
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.dataset.label || '';
              var unit = context.dataset.unit;
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += `${context.parsed.y} ${unit}`;
              }
              return label;
            },
          },
        },
      },
      scales: {
        x: {
          type: 'time',
          title: {
            display: false,
            text: 'Time',
            color: '#191',
            font: {
              family: 'Times',
              size: 20,
              style: 'normal',
              lineHeight: 1.2,
            },
          },
          time: {
            unit: 'day',
          },
        },
        y: {
          type: 'linear',
          display: true,
          position: 'left',
          title: {
            display: false,
            text: 'Output Energy (kWh)',
            color: '#038cfc',
            font: {
              family: 'Times',
              size: 20,
              style: 'normal',
              lineHeight: 1.2,
            },
          },
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return `${value} kWh`;
            },
          },
        },
        y1: {
          type: 'linear',
          display: true,
          position: 'right',
          title: {
            display: false,
            text: 'Performance Ratio (%)',
            color: '#fcc603',
            font: {
              family: 'Times',
              size: 20,
              style: 'normal',
              lineHeight: 1.2,
            },
          },
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return `${value} %`;
            },
          },
          grid: {
            drawOnChartArea: false, // only want the grid lines for one axis to show up
          },
          min: 0,
        },
      },
    },
  };

  const handlePickerChangeTwo = (e) => {
    // setIsPickerTwo(e.target.value);
    let content = '';
    let time = '';
    if (e.target.value === 'month') {
      content = 'month';
      time = `${moment(dateTime).format('YYYY-MM')}`;
    } else if (e.target.value === 'year') {
      content = 'year';
      time = `${moment(dateTime).format('YYYY')}`;
    } else {
      // content = 'daily-of-a-week';
      content = 'week';
      time = `${moment(dateTime).format('YYYY')}-${parseInt(moment(dateTime).format('WW')) + 1}`;
    }
    getDataPerformanceChart(false, time, content);
    setIsTitle(content);
  };

  const onChangeDatePicker = async (date) => {
    let time = '';
    if (isTitle === 'week') {
      time = `${moment(date).format('YYYY')}-${parseInt(moment(date).format('WW')) + 1}`;
    } else if (isTitle === 'month') {
      time = `${moment(date).format('YYYY-MM')}`;
    } else {
      time = `${moment(date).format('YYYY')}`;
    }
    getDataPerformanceChart(false, time, isTitle);
    setDateTime(date);
  };

  return (
    <div className="chart-plant-one">
      <div className={style.header_chart}>
        <DatePicker
          picker={isTitle}
          value={moment(dateTime)}
          onChange={onChangeDatePicker}
        />
        <Radio.Group
          style={{ display: 'flex' }}
          value={isTitle}
          onChange={handlePickerChangeTwo}
        >
          <Radio.Button value="week">Week</Radio.Button>
          <Radio.Button value="month">Month</Radio.Button>
          <Radio.Button value="year">Year</Radio.Button>
          <Radio.Button disabled value="year">
            Total
          </Radio.Button>
        </Radio.Group>
      </div>
      <div className={style.chart}>
        <canvas ref={chartRef} />
      </div>
    </div>
  );
}
ChartPerformance.propTypes = {
  getDataPerformanceChart: PropTypes.func,
  dateTime: PropTypes.string.isRequired,
  isTitle: PropTypes.string.isRequired,
  setDateTime: PropTypes.func,
  setIsTitle: PropTypes.func,
  dataChart: PropTypes.shape({
    output_e: PropTypes.arrayOf(
      PropTypes.shape({
        ts: PropTypes.number.isRequired,
        value: PropTypes.number,
      })
    ),
    performance_ratio: PropTypes.arrayOf(
      PropTypes.shape({
        ts: PropTypes.number.isRequired,
        value: PropTypes.number,
      })
    ),
    estimated_e: PropTypes.arrayOf(
      PropTypes.shape({
        ts: PropTypes.number.isRequired,
        value: PropTypes.number,
      })
    ),
  }).isRequired,
};
